import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { keywordsForHelpTopic } from 'rise-ui/config/help-topic-keywords.js';
import strings from 'rise-ui/config/strings.js';
import { helpSearchRouteQueryParams } from 'rise-ui/services/help-search.js';
import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

const filterFields = [
  [ 'title', 't' ],
  [ 'body.value', 'v' ],
  [ 'body.format', 'f' ],
  [ 'body.summary', 's' ],
];

@scrollRoot
export default class HelpSearchRoute extends Route {
  @service helpSearch;
  @service keywords;
  @service store;

  queryParams = helpSearchRouteQueryParams;

  setHeadTags(model) {
    const { topic } = this.helpSearch;
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: topic === 'topic2' ? strings['help-catalog-meta-description']
            : topic === 'topic3' ? strings['help-time-series-meta-description']
            : topic === 'topic4' ? strings['help-map-meta-description']
            // : topic === 'topic5' ? strings['help-visualizations-meta-description']
            : topic === 'topic7' ? strings['help-faq-meta-description']
            : topic === 'topic8' ? strings['help-api-meta-description']
            : topic === 'topic9' ? strings['help-download-api-meta-description']
            : strings['help-search-meta-description']
          ,
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            strings['data-keywords'],
            keywordsForHelpTopic(topic),
          ),
        },
      },
    ];
  }

  @breadcrumb crumb = 'Search';

  model(params) {
    this.helpSearch.setParams(params);
    let { search, terms, topic = '' } = this.helpSearch;
    const helpPages = this.store.queryWithCache('help-search', 'help-page', terms.reduce(
      (qps, word, i) => filterFields
        .reduce((fields, [ field, abbr ]) => ({
          ...fields,
          [`filter[${abbr}${i}][condition][memberOf]`]: 'search',
          [`filter[${abbr}${i}][condition][path]`]:     field,
          [`filter[${abbr}${i}][condition][operator]`]: 'CONTAINS',
          [`filter[${abbr}${i}][condition][value]`]:    word,
        }), qps),
      {
        'filter[search][group][conjunction]': 'OR',
        ...(topic ? { 'filter[field_select_help_topic]': topic } : {}),
      }
    ));
    helpPages.terms = terms;
    this.helpSearch.setResults(helpPages);
    return hash({
      search,
      helpTopicId: topic,
      helpTopicField: this.modelFor('help').helpTopicField,
      helpPages,
    });
  }

  resetController(controller, isExiting, transition) {
    if (isExiting) {
      const params = { search: undefined, topic: undefined };
      controller.setProperties(params);
      this.helpSearch.setParams(params);
    }
  }
}
